// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"382":"versions-sidebar","735":"docgen-sidebar","744":"metadata-sidebar","806":"activity-sidebar","836":"details-sidebar","885":"skills-sidebar"}[chunkId] + "." + {"382":"50fe7973","735":"f9a5a12c","744":"49722b00","806":"d1286933","836":"07025fd2","885":"3b05354a"}[chunkId] + ".chunk.css";
};